import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';


import lightGallery from 'lightgallery';
import lightGalleryCSS from 'lightgallery/dist/css/lightgallery.css';

import ScrollReveal from "scrollreveal";


import fontAwesome from 'font-awesome/scss/font-awesome.scss';
import OwlCss from 'owl.carousel/dist/assets/owl.carousel.css';
import OwlThemeCss from 'owl.carousel/dist/assets/owl.theme.default.css';

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children('.l-footer__menutitle').toggleClass('is-open');
        $(this).children('.l-footer__menulist.is-sub').slideToggle();
      });
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false;
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: false,
          autoplay: true,
          autoplayTimeout: 7000,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
          navText: ['<img src="/wp-content/themes/tgmetal-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/tgmetal-html/dist/assets/images/icon-slider-next.svg" />']
        });
      });

      var topAnim = function () {
        if ($('.c-main-visual').length == 0) {
          return false;
        }

        $('.c-main-visual').on('animationend webkitAnimationEnd', function (e) {
          if ($(e.target)[0].className == 'c-main-visual__logo') {
            $('.l-header-minimal.is-top').addClass('is-show');
            $('.c-main-visual__inner').delay(2000).queue(function(next) {
              $(this).addClass('is-animated');
              next();
            });
          }
          if ($(e.target)[0].className == 'c-main-visual__inner') {
            $('.c-main-visual__inner').addClass('is-animated');
          }
        });
      }();
    }

    // lightGallery
    function lightGallery() {
      $('.c-works-card__wrap').lightGallery({
        selector: '.c-works-card__image-wrap',
        mode: 'lg-fade'
      });
      $('.js-lightgallery').lightGallery({
        selector: '.js-lightgallery-item',
        mode: 'lg-fade'
      });
    }

    function showHideForm() {
      var text = $('.c-forms-onecolumn__radio input[type=radio]:checked').val();
      if (text.indexOf( "TGメタル") === -1) {
        $('.c-form-second').addClass('is-hide');
      } else {
        $('.c-form-second').removeClass('is-hide');
      }
    }
    function checkButton() {

      if( $('.mw_wp_form_input .c-forms-onecolumn__radio input[type=radio]').length > 0 ) {
        $('.c-forms-onecolumn__radio input[type=radio]').change(function () {
          showHideForm();
        });
        showHideForm();
      } else {

      }
    }

    function accordionOpen() {
      $(window).on('load', function () {
        if ($('#products-list').length == 0) {
          return false;
        }
        if (document.location.href.match(/\?/)) {
          $('.c-works-accordion').addClass('is-open');
          $('.c-works-accordion__content').slideToggle();
          //$('.l-header-minimal').css('display', 'none');
        }
      });
    }

    function reveal() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600, mobile: false});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }


      sr.reveal(".l-page-header__title", {scale: 1, duration: 600, origin: 'top', distance: '10px',easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)'}, 100);
      sr.reveal(".l-page-header__subtitle", {scale: 1, duration: 600, delay:200, origin: 'top', distance: '10px',easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)'}, 100);

      var blocks01 = $(".c-special-block, .c-super-block, .c-special-block-lg");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {viewFactor: 0.3, delay: 0, scale: 1, origin: 'top', distance: '40px',easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)'}, 100);
        sr.reveal(item.children[1], {viewFactor: 0.3, delay: 200, scale: 1, origin: 'top', distance: '40px',easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)'}, 100);
        sr.reveal(item.children[2], {viewFactor: 0.3, delay: 400, scale: 1, origin: 'top', distance: '40px',easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)'}, 100);
        sr.reveal(item.children[3], {viewFactor: 0.3, delay: 600, scale: 1, origin: 'top', distance: '40px',easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)'}, 100);
        sr.reveal(item.children[4], {viewFactor: 0.3, delay: 800, scale: 1, origin: 'top', distance: '40px',easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)'}, 100);
      });

      function myCallback(el) {
        el.classList.add('is-animating');
      }

      ScrollReveal().reveal('#example', {beforeReveal: myCallback});
    }

    function mainvisualHeightSet() {
      $(window).on('load', function() {
        var winW = $(window).innerWidth();
        var winH = $(window).innerHeight();
        if(winW <= '750') {
          $('.c-main-visual__image').css('height', winH + 'px');
        }
      });
    }


    $(function () {
      menuSlide();
      owlCarousel();
      lightGallery();
      checkButton();
      accordionOpen();
      reveal();
      mainvisualHeightSet();
    });
  }
}

window.GApp = new App();


